import React from 'react';
import styled from 'styled-components';

const OrDividerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 8px;
  gap: 24px;
`;

const OrLine = styled.div`
  height: 1px;
  background: var(--color-border-primary);
  width: 100%;
`;

const OrText = styled.p`
  color: var(--color-text-muted);
  font-weight: 600;
  font-size: 14px;
`;

const OrDivider = () => {
  return (
    <OrDividerContainer>
      <OrLine />
      <OrText>OR</OrText>
      <OrLine />
    </OrDividerContainer>
  );
};

export default OrDivider;
